import React, { Fragment, memo, useCallback } from 'react'
import PropTypes from 'prop-types'
import CloudUploadTwoToneIcon from '@mui/icons-material/CloudUploadTwoTone';

import { Button, Modal } from '../../../components/Common'

import { useDispatch } from 'react-redux'
import { useDropzone } from 'react-dropzone'

import { sendMsgAction, skipGAEventAction, uploadAction } from '../../../utils/actions'
import { concatClasses, hashCode } from '../../../utils/fns'
import { useModal } from '../../../utils/hooks'

const Upload = ({ appCode, className, disabled }) => {
  const dispatch = useDispatch()

  const [show, onHide] = useModal(false)

  const cancelUpload = () => {
    dispatch(sendMsgAction({ description: 'File upload cancelled.' }))
    onHide()
  }

  const onDrop = useCallback(
    (acceptedFiles) => {
      const reader = new FileReader()
      reader.onload = () => {
        const binaryStr = reader.result
        let uploadedObj = null

        try {
          uploadedObj = JSON.parse(binaryStr)
        } catch (error) {
          console.log('JSON.parse error:', error)
        }

        if (!!uploadedObj && !!uploadedObj.hash && !!uploadedObj.source) {
          const hashFromDownload = uploadedObj.hash

          const uploadedSourceStr = JSON.stringify(uploadedObj.source, null, 0)
          const computedHash = hashCode(uploadedSourceStr)

          if (hashFromDownload === computedHash) {
            const { appCode: uploadedAppCode } = uploadedObj.source

            if (uploadedAppCode === appCode /* && appVersion === props.appConfig.appVersion */) {
              dispatch(uploadAction(uploadedObj.source))
              dispatch(
                sendMsgAction({
                  level: 'success',
                  description: 'File uploaded',
                }),
              )
              dispatch(skipGAEventAction(true))
            } else {
              dispatch(
                sendMsgAction({
                  level: 'error',
                  description: 'Invalid app; upload rejected',
                }),
              )
            }
          } else {
            dispatch(
              sendMsgAction({
                level: 'error',
                description: 'Invalid app; upload rejected',
              }),
            )
          }
        } else {
          dispatch(
            sendMsgAction({
              level: 'error',
              description: 'Invalid file format; upload rejected',
            }),
          )
        }
      }

      acceptedFiles.forEach((file) => reader.readAsText(file))
      onHide()
    },
    [show],
  )

  const { getRootProps, getInputProps } = useDropzone({ onDrop })

  return (
    <Fragment>
      <Button
        variant="topNav"
        className={concatClasses('button topNav__button -upload', className)}
        disabled={disabled}
        onClick={onHide}
      >
        <CloudUploadTwoToneIcon className='material-icons-two-tone' />
        <span className="button__text">Upload</span>
      </Button>
      <Modal
        className="upload"
        show={show}
        onHide={cancelUpload}
        header={
          <Modal.Header closeButton>
            <h3>Upload File</h3>
          </Modal.Header>
        }
        footer={
          <Modal.Footer>
            <Button variant="text" onClick={cancelUpload}>
              <span className="material-icons">close</span>
              <span className="button__text">Cancel</span>
            </Button>
          </Modal.Footer>
        }
      >
        <div className="fileUploadZone" {...getRootProps()}>
          <span className="">
            <span>Drag and drop a file here or </span>
            <button type="button" className="button -link">
              <span className="button__text">browse files</span>
            </button>
          </span>
          <input {...getInputProps({ multiple: false })} />
        </div>
      </Modal>
    </Fragment>
  )
}

Upload.propTypes = {
  appCode: PropTypes.string.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
}

Upload.defaultProps = {
  disabled: false,
  className: '',
}

export default memo(Upload)
